import React from 'react';
import { SwipeableDrawer, Box, Typography, Checkbox, FormControlLabel, Switch, IconButton} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import { CategoryLabels, KeyLabels, AdmLabels, categories as defaultCategories, admlayers as defaultAdmLayers } from '../../Constants/GeologicalOptions.js';

const MobileDrawer = ({
                          filterOpen,
                          setFilterOpen,
                          selectedCategories,
                          selectedKeys,
                          selectedAdmLayers,
                          handleCategoryToggle,
                          handleKeyToggle,
                          handleAdmLayerToggle,
                          categories = defaultCategories,
                          admlayers = defaultAdmLayers
                      }) => {
    const { t } = useTranslation();
    return (
        <SwipeableDrawer
            anchor="left"
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            onOpen={() => setFilterOpen(true)}
            disableBackdropTransition={true}
            disableDiscovery={true}
        >
            <Box sx={{ width: 280, p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">{t('Feltarasok.Title')}</Typography>
                    <IconButton onClick={() => setFilterOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
                
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>{t('Feltarasok.Categories')}</Typography>
                {Object.entries(categories).map(([category, keys]) => (
                    <Box key={category} sx={{ mb: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>{t(`Categories.${category}`)}</Typography>
                            <Switch
                                size="small"
                                checked={selectedCategories.includes(category)}
                                onChange={() => handleCategoryToggle(category)}
                            />
                        </Box>
                        <Box sx={{ ml: 2, display: 'flex', flexDirection: 'column' }}>
                            {keys.map(key => (
                                <FormControlLabel
                                    key={key}
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={selectedKeys[category] ? selectedKeys[category][key] : false}
                                            onChange={() => handleKeyToggle(category)(key)}
                                            disabled={!selectedCategories.includes(category)}
                                        />
                                    }
                                    label={<Typography variant="body2">{t(`Keys.${key}`)}</Typography>}
                                />
                            ))}
                        </Box>
                    </Box>
                ))}

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 3, mb: 1 }}>{t('Feltarasok.AdminLayers')}</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {Object.keys(admlayers).map(admlayer => (
                        <Box key={admlayer} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="body2">{t(`Adm.${admlayer}`)}</Typography>
                            <Switch
                                size="small"
                                checked={selectedAdmLayers.includes(admlayer)}
                                onChange={() => handleAdmLayerToggle(admlayer)}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </SwipeableDrawer>
    );
};

export default MobileDrawer;
